const REGEX = {
  LEGAL_NAME: /^[a-zA-Z,.']+(?:\s[a-zA-Z,.']+)*$/
}

const INDO = {
  CALLING_CODE: "+62",
  COUNTRY_CODE: "62",
  ISO_COUNTRY_CODE: "ID",
  CURRENCY: "IDR",
}

const FOREIGNER = {
  LOCALE: "en-UK",
  CURRENCY: "USD",
  ROUTE_PATH_PREFIX: "/en",
  ROUTE_NAME_SUFFIX: "Foreigner"
}
const OTP_METHOD = {
  INPUT_OTP: "input_otp",
  REVERSE_OTP: "reverse_otp",
}
const OTP_TYPE = {
  SMS: "sms",
  RADIST: "waba_radist",
  TWILIO: "waba_twilio",
}
const OTP_STATUS = {
  QUEUED: "Queued",
  DELIVERED: "Delivered",
  UNDELIVERED: "Undelivered",
  ERROR: "Error",
  READ: "Read",
  FAILED: "Failed",
  SENT: "Sent",
}
const STATUS = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RECEIVED: "RECEIVED",
  FAILED: "FAILED",
  PAID: "PAID",
  EXPIRED: "EXPIRED",
  COMPLETED: "COMPLETED",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED",
  SWAPPED: "SWAPPED",
  UNCLAIM: "UNCLAIM",
  PROCESSING: "PROCESSING",
}

const PROPERTY_APPROVAL_STATUS = {
  PRE_APPROVED: "PRE_APPROVED",
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  APPROVED: "APPROVED"
}

const PROPERTY_APPROVAL_STATUS_LIST = [
  { value: "", text: "Property Approval Status" },
  { value: "PRE_APPROVED", text: "Pre Approved" },
  { value: "DRAFT", text: "Draft" },
  { value: "PENDING", text: "Pending" },
  { value: "APPROVED", text: "Approved" },
]

const PROPERTY_RUNNING_OUT_THRESHOLD_TYPES = [
  { value: null, text: "Type" },
  { value: "AMOUNT", text: "Fixed Amount" },
  { value: "PERCENTAGE", text: "Percentage" },
]

const STATUS_CODE = {
  HTTP_UNAUTHORIZED: 401,
  HTTP_NOT_FOUND: 404,
  HTTP_TOO_EARLY: 425,
  HTTP_TOO_MANY_REQUESTS: 429,
  HTTP_UPGRADE_REQUIRED: 426,
  HTTP_PRECONDITION_REQUIRED: 428,
}

const TRANSACTION_TYPE = {
  ALL: "ALL",
  BUY_TOKEN: "BUY_TOKEN",
  ORDER_TOKEN: "ORDER_TOKEN",
  SELL_TOKEN: "SELL_TOKEN",
  REFERRAL_BONUS: "REFERRAL_BONUS",
  REFERRAL_BONUS_TOKEN: "REFERRAL_BONUS_TOKEN",
  REWARD_BONUS: "REWARD_BONUS",
  REWARD_BONUS_TOKEN: "REWARD_BONUS_TOKEN",
  WITHDRAWAL: "WITHDRAWAL",
  RENTAL_DISTRIBUTION: "RENTAL_DISTRIBUTION",
  DONATION_RENTAL_INCOME: "DONATION_RENTAL_INCOME",
  ADMIN_ADD_BALANCE: "ADMIN_ADD_BALANCE",
  BUY_TOKEN_VIRTUAL_BALANCE: "BUY_TOKEN_VIRTUAL_BALANCE",
  VIRTUAL_RENTAL_DISTRIBUTION: "VIRTUAL_RENTAL_DISTRIBUTION",
  ADMIN_DEDUCT_BALANCE: "ADMIN_DEDUCT_BALANCE",
  SYSTEM_ADD_BALANCE: "SYSTEM_ADD_BALANCE",
  SYSTEM_DEDUCT_BALANCE: "SYSTEM_DEDUCT_BALANCE",
  ADMIN_DONATION_DISTRIBUTION: "ADMIN_DONATION_DISTRIBUTION",
}

// SYSTEM_ADD_BALANCE rows with these sub_types are balance returns (labelled "Refund");
// every other sub_type is a credit of external money (labelled "Credited").
const TRANSACTION_RETURN_SUB_TYPES = ["PAYMENT_EXPIRED_RETURN", "REJECT_ORDER_RETURN", "WITHDRAWAL_RETURN"]

// The only return caused by expiry — labelled "Expiry refund"; it pairs with a later
// SYSTEM_DEDUCT_BALANCE ("Paid after expiry") when the gateway confirms late.
const TRANSACTION_SUB_TYPE_PAYMENT_EXPIRED_RETURN = "PAYMENT_EXPIRED_RETURN"

// Display-only key for locale lookup; never sent by or to the backend.
const TRANSACTION_DISPLAY_TYPE_SYSTEM_ADD_BALANCE_RETURN = "SYSTEM_ADD_BALANCE_RETURN"

const PENDING_TASK_TYPE = {
  AGREE_TO_CONTRACT: "AGREE_TO_CONTRACT",
  CLAIM_VIRTUAL_RENTAL_INCOME: "CLAIM_VIRTUAL_RENTAL_INCOME",
  CLAIM_REFERRAL_BONUS: "CLAIM_REFERRAL_BONUS"
}

const TASK_STATUSES = {
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  COMPLETED: "COMPLETED",
}

const ERROR_CODE = {
  KYC_REQUIRED: "ERROR_KYC_REQUIRED",
  KYC_PHASE_2_REQUIRED: "ERROR_KYC_PHASE_2_REQUIRED",
  RECAPTCHA_ERROR_INVALID_TOKEN: 'RECAPTCHA_ERROR_INVALID_TOKEN',
  RECAPTCHA_ERROR_INVALID_TOKEN_V2: 'RECAPTCHA_ERROR_INVALID_TOKEN_V2',
  RECAPTCHA_ERROR_SCORE_TOO_LOW: 'RECAPTCHA_ERROR_SCORE_TOO_LOW',
  RECAPTCHA_ERROR_ACTION_DOES_NOT_MATCH: 'RECAPTCHA_ERROR_ACTION_DOES_NOT_MATCH',
}

const FINANCIAL_SUBHEADER = {
  ASSET_VALUE: "ASSET_VALUE",
  ANNUAL_RETURN: "ANNUAL_RETURN",
}

const PAYMENT_METHOD = {
  XENDIT: "XENDIT",
  STRIPE: "STRIPE"
}

const WITHDRAWAL_METHOD = {
  XENDIT: "XENDIT",
  PAYPAL: "PAYPAL",
  BANK_ACCOUNT: "BANK_ACCOUNT"
}

const BANK_TYPE = {
  FOREIGNER: "FOREIGNER",
  INDO_USER: "INDO_USER"
}

const WITHDRAWAL_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  PENDING_PROCESS: "PENDING_PROCESS",
  PROCESSING: "PROCESSING",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  COMPLETED: "COMPLETED",
}

const BANK_ACCOUNT_STATUS = {
  PENDING: "PENDING",
  FAILED: "FAILED",
  NEED_CONFIRM_NAME: "NEED_CONFIRM_NAME",
  NEED_CONFIRM_EMAIL: "NEED_CONFIRM_EMAIL",
  CONFIRMED: "CONFIRMED",
  DEACTIVATED: "DEACTIVATED",
}

// Filter values accepted by GET withdrawals?status= (backend Withdrawal::HISTORY_FILTER_STATUS_MAP)
const WITHDRAWAL_FILTER_STATUSES = ["PROCESSED", "COMPLETED", "FAILED", "CANCELLED", "REJECTED"]

// Filter values accepted by GET bank-account/history?status= (backend BankAccountHistory::HISTORY_FILTER_STATUS_MAP)
const BANK_ACCOUNT_FILTER_STATUSES = ["PENDING", "NEED_CONFIRM", "CONFIRMED", "FAILED", "DEACTIVATED"]

const PROPERTY_STATUSES = {
  SOLD: "sold"
}

const PROPERTY_STATUSES_LIST = [
  { value: "", text: "Property status" },
  { value: "available", text: "Available" },
  { value: "promo", text: "Promo" },
  { value: "presale", text: "Presale" },
  { value: "sold", text: "Sold Out" },
  { value: "coming_soon", text: "Coming Soon" },
  { value: 'draft', text: 'Draft' },
]

// Bond Listing Constants
const BOND_LISTING_STATUSES = {
  AVAILABLE: "available",
  PROMO: "promo",
  PRESALE: "presale",
  SOLD_OUT: "sold_out",
  COMING_SOON: "coming_soon",
  DRAFT: "draft",
  MATURED: "matured",
}

const BOND_LISTING_STATUSES_LIST = [
  { value: "", text: "Bond Listing Status" },
  { value: "available", text: "Available" },
  { value: "promo", text: "Promo" },
  { value: "presale", text: "Presale" },
  { value: "sold_out", text: "Sold Out" },
  { value: "coming_soon", text: "Coming Soon" },
  { value: "draft", text: "Draft" },
  { value: "matured", text: "Matured" },
]

const BOND_LISTING_APPROVAL_STATUS = {
  PRE_APPROVED: "PRE_APPROVED",
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  APPROVED: "APPROVED"
}

const BOND_LISTING_APPROVAL_STATUS_LIST = [
  { value: "", text: "Bond Listing Approval Status" },
  { value: "PRE_APPROVED", text: "Pre Approved" },
  { value: "DRAFT", text: "Draft" },
  { value: "PENDING", text: "Pending" },
  { value: "APPROVED", text: "Approved" },
]

const BOND_LISTING_INSTRUMENT_TYPES = [
  { value: "", text: "Instrument Type" },
  { value: "bond", text: "Bond" },
  { value: "sukuk", text: "Sukuk" },
  { value: "eba", text: "EBA" },
]

const BOND_LISTING_CATEGORIES = [
  { value: "", text: "Select Category" },
  { value: "syariah", text: "Syariah" },
  { value: "non_syariah", text: "Non-Syariah" },
]

const BOND_LISTING_CUSTOM_ACTIONS = {
  UPDATE_RENTAL_DISTRIBUTION: {
    label: 'Rental Distribution',
    key: 'update-rental-distribution'
  },
  VIEW_BOND_LISTING_HOLDER: {
    label: 'Holders',
    key: 'view-bond-listing-holder'
  },
  VIEW_BOND_LISTING_MILESTONE: {
    label: 'Milestone',
    key: 'view-all-milestone'
  },
  VIEW_BOND_LISTING_FINANCIALS: {
    label: 'Financials',
    key: 'view-all-financials'
  },
  UPDATE_BOND_LISTING_STATUS_AND_TOKEN: {
    label: 'Update Status and Token',
    key: 'update-bond-listing-status-and-token'
  },
  VIEW_BOND_LISTING: {
    label: 'View',
    key: 'view-bond-listing'
  },
  UPDATE_BOND_LISTING_DETAIL: {
    label: 'Modify',
    key: 'update-bond-listing-detail'
  },
  UPDATE_BOND_LISTING_STATUS_TOKEN: {
    label: 'Status & Token',
    key: 'bond-listing-status-token-view'
  },
  COPY_BOND_LISTING: {
    label: 'Copy',
    key: 'copy-bond-listing'
  },
  APPROVE_BOND_LISTING_PUBLISH: {
    label: 'Approve',
    key: 'approve-bond-listing-publish'
  },
}

const PROPERTY_CUSTOM_ACTIONS = {
  UPDATE_RENTAL_DISTRIBUTION: {
    label: 'Rental Distribution',
    key: 'update-rental-distribution'
  },
  VIEW_PROPERTY_HOLDER: {
    label: 'Holders',
    key: 'view-property-holder'
  },
  VIEW_PROPERTY_IMAGE: {
    label: 'Images Visibility',
    key: 'view-property-image'
  },
  VIEW_PROPERTY_MILESTONE: {
    label: 'Milestone',
    key: 'view-all-milestone'
  },
  VIEW_ALL_FINANCIALS: {
    label: 'Financials',
    key: 'view-all-financials'
  },
  UPDATE_PROPERTY_STATUS_AND_TOKEN: {
    label: 'Update Status and Token',
    key: 'update-property-status-and-token'
  },
  VIEW_PROPERTY: {
    label: 'View',
    key: 'view-property'
  },
  UPDATE_PROPERY_DETAIL: {
    label: 'Modify',
    key: 'update-property-detail'
  },
  UPDATE_PROPERTY_STATUS_TOKEN: {
    label: 'Status & Token',
    key: 'property-status-token-view'
  },
  COPY_PROPERTY: {
    label: 'Copy',
    key: 'copy-property'
  },
  APPROVE_PROPERTY_PUBLISH: {
    label: 'Approve',
    key: 'approve-property-publish'
  },
}

const USER_CUSTOM_ACTIONS = {
  VIEW_USER_ASSETS: {
    label: 'Assets',
    key: 'view-user-assets'
  },
  VIEW_USER_VIRTUAL_ASSETS: {
    label: 'Virtual Assets',
    key: 'view-user-virtual-assets'
  },
  VIEW_USER_KTP_PASSPORT: {
    label: 'KTP/Passport',
    key: 'view-user-ktp-passport'
  },
  VIEW_USER_VERIFY_SELFIE: {
    label: 'Verify Selfie',
    key: 'view-user-verify-selfie'
  },
  VIEW_USER_FLAG: {
    label: 'Flag User',
    key: 'view-user-flag'
  },
  VIEW_KYC_USER_STATUS: {
    label: 'KYC CDD',
    key: 'view-kyc-user-status'
  },
  CALL_KYC_CDD_COMPLETE: {
    label: 'Call KYC CDD',
    key: 'call-kyc-cdd-complete'
  },
}

const PROPERTY_SHOW_MODE_STATUS = {
  ALL: "all"
}

const TRANSACTION_CUSTOM_ACTIONS = {
  VIEW_TRANSACTION_DETAILS: {
    label: 'Details',
    key: 'view-transaction-detail'
  },
}

const BLOCKCHAIN = {
  POLYGON_NETWORK: process.env.VUE_APP_POLYGON_NETWORK,
  BLOCKCHAIN_EXPLORER_ADDRESS_URL: process.env.VUE_APP_BLOCKCHAIN_EXPLORER_ADDRESS_URL,
  BLOCKCHAIN_EXPLORER_TRANSACTION_URL: process.env.VUE_APP_BLOCKCHAIN_EXPLORER_TRANSACTION_URL,
}

const ROUTE_META_PAGE_TYPES = {
  ADMIN: 'ADMIN',
  ACCOUNT: 'ACCOUNT',
  GUEST: 'GUEST'
}

const ADMIN_LOGS_CUSTOM_ACTIONS = {
  SHOW_CHANGES: {
    label: 'Show Changes',
    key: 'show-changes'
  }
}

const PARTNER_PICK_DATE_VALUES = {
  DEFAULT: 31
}

const DATE_TIME_FORMATS = {
  PICK_DATE: "DD/MM/YYYY"
}

const STORAGE_KEYS = {
  AUTHORIZATION: { key: "Authorization", type: "standard" },
  SELL_TOKEN_TRANSACTION_FEE_CONFIRMATION: { key: "sell_token_transaction_fee_confirmation", type: "standard" },
  SWAP_TOKEN_TRANSACTION_FEE_CONFIRMATION: { key: "swap_token_transaction_fee_confirmation", type: "standard" },

  EVENT_ACTIVES: { key: "active_events", type: "permanent" },
  REFERRAL_CODE: { key: "referral_code", type: "permanent" },
  PREFERRED_LOCALE: { key: "preferred_locale", type: "permanent" },
  PRE_REGISTERED_UUID: { key: "pre_registered_uuid", type: "permanent" },
  SANDBOX_MODAL_EXPIRY: { key: "sandbox_modal_expiry", type: "permanent" },

  //Meta Pixel
  FBCLID: { key: "fbclid", type: "standard" },
  FBC: { key: "fbc", type: "permanent" },
}

const STORAGE_ACTION_KEYS = {
  GET_UNCLAIM_REWARD_TRANSACTIONS_COUNT: "get-unclaim-reward-transactions-count",
  GET_UNREAD_COUNT: "get-unread-count",
  GET_PLAYLISTS: "get-playlists",
  GET_BANKS: "get-banks",
}

// Admin config changes reach the client through `refreshConfig`, which only
// runs on a full page load. Without a periodic refresh a long-lived SPA session
// keeps serving the localStorage-persisted copy indefinitely. Tighter than the
// mobile app's 20-minute cadence (config_notifier.dart) because the web session
// is the one that stays open for hours. Short retry so a failed load doesn't
// strand the session on backend defaults until the next reload.
const CONFIG_REFRESH = {
  INTERVAL_MS: 2 * 60 * 1000,
  RETRY_INTERVAL_MS: 5 * 1000,
}

const DOCUMENT_VERSIONING_TYPES = {
  USER_CONSENT: "USER_CONSENT",
  PRIVACY_POLICY: "PRIVACY_POLICY",
  TERMS_AND_CONDITION: "TERMS_AND_CONDITION"
}

const EVENT_TYPES = {
  TYPE_STANDARD: "STANDARD",
  TYPE_SULTAN_JURAGAN: "SULTAN_JURAGAN",
  TYPE_REFERRAL: "REFERRAL",
  TYPE_TREASURE_HUNT: "TREASURE_HUNT",
  TYPE_CAMPAIGN: "CAMPAIGN",
  TYPE_SATSET: "SATSET",
}

const EVENT_STATUS = {
  UPCOMING: "Upcoming",
  ONGOING: "Ongoing",
  ENDED: "Ended",
}

const KYC_CARD_TYPES = {
  INDONESIA_KTP: 'indonesia_ktp',
  PASSPORT: 'passport'
}

const KYC_PHASE_2_STATUS = {
  STATUS_PENDING: 'PENDING',
  STATUS_UNDER_REVIEW: 'UNDER_REVIEW',
  STATUS_ASSESSMENT: 'ASSESSMENT',
  STATUS_INTERVIEW: 'INTERVIEW',
  STATUS_REVIEWING: 'REVIEWING',
  STATUS_COMPLETED: 'COMPLETED',
  STATUS_FAILED: 'FAILED',
}

const KYC_PHASE_2_FLAGS = {
  PEP: 'PEP',
  BO: 'BO',
}

const PRE_REGISTERED_STATUSES = {
  VERIFY_OTP: "VERIFY_OTP",
  UPDATE_INFO: "UPDATE_INFO",
  REVIEW_INFO: "REVIEW_INFO",
  PARENTAL_KYC: "PARENTAL_KYC",
  PARENTAL_KYC_REVIEWED: "PARENTAL_KYC_REVIEWED",
  PARENTAL_KYC_SUCCESS: "PARENTAL_KYC_SUCCESS",
  PARENTAL_KYC_FAILED: "PARENTAL_KYC_FAILED",
  CREATE_PASSWORD: "CREATE_PASSWORD",
  COMPLETED: "COMPLETED",
}

const MARITAL_STATUS = {
  SINGLE: 'single',
  MARRIED: 'married',
  DIVORCED: 'divorced',
  WIDOWED: 'widowed',
}

const CONFIG = {
  FEE_TYPE_BALANCE: 'BALANCE',
  FEE_TYPE_PERCENTAGE: 'PERCENTAGE',
}

const VOUCHER = {
  TYPE_SINGLE: 'SINGLE',
  TYPE_MULTIPLE: 'MULTIPLE',

  REWARD_TYPE_REDUCE_ANY_FEES: 'REDUCE_ANY_FEES',
  // Buy
  REWARD_TYPE_DISCOUNT: 'DISCOUNT',
  REWARD_TYPE_REDUCE_FEE_BUY: 'REDUCE_FEE_BUY',
  REWARD_TYPE_REDUCE_TRANSACTION_FEE_BUY: 'REDUCE_TRANSACTION_FEE_BUY',
  REWARD_TYPE_REDUCE_ANY_FEES_BUY: 'REDUCE_ANY_FEES_BUY',
  // Sell
  REWARD_TYPE_REDUCE_TRANSACTION_FEE_SELL: 'REDUCE_TRANSACTION_FEE_SELL',
  // Swap
  REWARD_TYPE_REDUCE_TRANSACTION_FEE_SWAP: 'REDUCE_TRANSACTION_FEE_SWAP',
  // Withdrawal
  REWARD_TYPE_REDUCE_FEE_WITHDRAWAL: 'REDUCE_FEE_WITHDRAWAL',
  //REWARD_TYPE_REDUCE_TRANSACTION_FEE_WITHDRAWAL: 'REDUCE_TRANSACTION_FEE_WITHDRAWAL',

  REWARD_AMOUNT_UNIT_BALANCE: 'BALANCE',
  REWARD_AMOUNT_UNIT_PERCENTAGE: 'PERCENTAGE',

  REDEEM_ACTION_PAYMENT: "PAYMENT",
  REDEEM_ACTION_ORDER: "ORDER",
  REDEEM_ACTION_SELL: "SELL",
  REDEEM_ACTION_SWAP: "SWAP",
  REDEEM_ACTION_WITHDRAWAL: "WITHDRAWAL",
}

const REWARD = {
  TYPE_SINGLE: 'single',
  TYPE_MULTIPLE: 'multiple',

  REWARD_TYPE_BALANCE: 'BALANCE',
  REWARD_TYPE_BONUS_TOKEN: 'BONUS_TOKEN',

  REDEMPTION_TYPE_TOKEN: 'TOKEN',
  REDEMPTION_TYPE_LOCKED_TOKEN: 'LOCKED_TOKEN',
  REDEMPTION_TYPE_BALANCE: 'BALANCE',
  REDEMPTION_TYPE_CONVERTED_TO_BALANCE: 'CONVERTED_TO_BALANCE',
}

const DONATION_PARTNER = {
  RUMAH_ZAKAT: 'RUMAH_ZAKAT',
  PARTNER_DISPLAY_NAMES: {
    RUMAH_ZAKAT: 'Rumah Zakat',
  },
}

const EVENT_BUS_EVENTS = {
  NOTIFICATION_CLAIMED: 'NOTIFICATION_CLAIMED'
}

const EVENT_REDIRECT_TYPES = {
  EXTERNAL_URL: 'EXTERNAL_URL',
  INTERNAL_SCREEN: 'INTERNAL_SCREEN'
}

export {
  REGEX,
  DONATION_PARTNER,
  INDO,
  FOREIGNER,
  OTP_METHOD,
  OTP_TYPE,
  OTP_STATUS,
  STATUS,
  STATUS_CODE,
  TRANSACTION_TYPE,
  TRANSACTION_RETURN_SUB_TYPES,
  TRANSACTION_SUB_TYPE_PAYMENT_EXPIRED_RETURN,
  TRANSACTION_DISPLAY_TYPE_SYSTEM_ADD_BALANCE_RETURN,
  PENDING_TASK_TYPE,
  ERROR_CODE,
  FINANCIAL_SUBHEADER,
  PAYMENT_METHOD,
  WITHDRAWAL_METHOD,
  BANK_TYPE,
  WITHDRAWAL_STATUS,
  BANK_ACCOUNT_STATUS,
  WITHDRAWAL_FILTER_STATUSES,
  BANK_ACCOUNT_FILTER_STATUSES,
  PROPERTY_STATUSES,
  PROPERTY_STATUSES_LIST,
  PROPERTY_CUSTOM_ACTIONS,
  USER_CUSTOM_ACTIONS,
  PROPERTY_SHOW_MODE_STATUS,
  BLOCKCHAIN,
  ROUTE_META_PAGE_TYPES,
  ADMIN_LOGS_CUSTOM_ACTIONS,
  PARTNER_PICK_DATE_VALUES,
  DATE_TIME_FORMATS,
  TRANSACTION_CUSTOM_ACTIONS,
  STORAGE_KEYS, STORAGE_ACTION_KEYS,
  CONFIG_REFRESH,
  TASK_STATUSES,
  DOCUMENT_VERSIONING_TYPES,
  PROPERTY_APPROVAL_STATUS,
  PROPERTY_APPROVAL_STATUS_LIST,
  PROPERTY_RUNNING_OUT_THRESHOLD_TYPES,
  EVENT_TYPES, EVENT_STATUS,
  KYC_CARD_TYPES, KYC_PHASE_2_STATUS, KYC_PHASE_2_FLAGS,
  PRE_REGISTERED_STATUSES,
  MARITAL_STATUS,
  CONFIG, VOUCHER, REWARD,
  EVENT_BUS_EVENTS,
  EVENT_REDIRECT_TYPES,
  // Bond Listing exports
  BOND_LISTING_STATUSES,
  BOND_LISTING_STATUSES_LIST,
  BOND_LISTING_APPROVAL_STATUS,
  BOND_LISTING_APPROVAL_STATUS_LIST,
  BOND_LISTING_INSTRUMENT_TYPES,
  BOND_LISTING_CATEGORIES,
  BOND_LISTING_CUSTOM_ACTIONS,
}
